export default "__VITE_ASSET__DHpac9Bt__"